import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from '../../../components/Login';

const CampLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const campId = searchParams.get('campId');
  const { isAuthenticated } = useSelector((state) => state.auth);
  const centerData = useSelector((state) => state.center);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      // Already logged in — go straight to registration
      navigate(`/camp/registration?campId=${campId}`, { replace: true });
    } else {
      setShowLogin(true);
    }
  }, [isAuthenticated]);

  const handleLoginSuccess = () => {
    navigate(`/camp/registration?campId=${campId}`, { replace: true });
  };

  const handleLoginCancel = () => {
    const centerId = centerData?.center_Id;
    const country = centerData?.country_Desc || 'USA';
    navigate(`/camp/selection?centerId=${centerId}&country=${country}`);
  };

  return (
    <>
      {showLogin && (
        <Login
          onLoginSuccess={handleLoginSuccess}
          onCancel={handleLoginCancel}
          entity="RMS"
        />
      )}
    </>
  );
};

export default CampLogin;
